<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Buscador de columnas</a>
    </div>
    <h1 class="ui header">
      <i class="icon file alternate outline"></i>
      <div class="content">Buscador de columnas</div>
    </h1>
    <div class="ui stackable">
      <div class="row">
        <h4 class="ui dividing header">Buscar una columna</h4>
        <div>
          <form class="ui form" @submit.prevent="searchAction">
            <div class="three fields">
              <div class="field">
                <sui-dropdown fluid search selection :options="aptsOptions" v-model="search.apt_id"
                  placeholder="Máquina" />
                <!-- Aquí tienen que estar todas las máquinas, incluso las desinstaladas -->
              </div>
              <div class="field">
                <sui-input placeholder="Id, Id Fabricante" icon="barcode" v-model="search.ref" />
              </div>

              <div class="field">
                <button class="ui button fluid" type="submit">Buscar</button>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div v-if="searching" class="ui active centered inline loader"></div>
      <div v-if="(rows.length != 0)" class="row">
        <div class="column">
          <b></b>
          <h4 class="ui dividing header">Total Columnas: {{ totalColumns }}</h4>
          <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
            perPage: 50,
            enabled: true,
            mode: 'pages'
          }" :sort-options="{
            enabled: true,
            //initialSortBy: { field: 'product_identifier', type: 'desc' }
          }" @on-row-click="columnInfo" styleClass="vgt-table striped condensed bordered">
            <template slot="table-row" slot-scope="props">
              <span style="text-align: center;" v-if="props.column.field == 'installed'">
                <h2><i v-if="props.row.installed" class="hapiick check icon"></i>
                  <i v-if="props.row.id && !props.row.installed" class="red times icon"></i>
                </h2>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'columnList',
  data() {
    return {
      totalColumns: 0,
      searching: false,
      search: {
        apt_id: null,
        ref: ""
      },
      columns: [
        {
          label: 'ID',
          field: 'product_identifier'
        },
        {
          label: 'ID Fabricante',
          field: 'product_identifier_prov'
        },
        {
          label: 'Tipo Columna',
          field: 'name',
        },
        {
          label: 'APM',
          field: 'apt_name'
        },
        {
          label: 'Almacen',
          field: 'store_name'
        },
        {
          label: 'Instalada en la máquina',
          field: 'installed'
        }
      ],
      rows: [],
      aptsOptions: []
    }
  },
  created() {
    const role = JSON.parse(localStorage.admin).role;

    if (role === 'master' || role === 'admin') {
      this.getDataFilters()
    } else {
      this.$router.replace('/inventory')
    }
  },
  methods: {
    async getDataFilters() {
      await hapiickApi().post('/v2/shipments/filters', {
        admin_id: JSON.parse(localStorage.admin).id,
        AptInServiceDeleted: true
      })
        .then(request => {
          let { aptsInServiceDeleted } = { ...request.data.data }
          this.fillAptsOptions(aptsInServiceDeleted);
        })
        .catch(() => console.log('error getting combo informations'))
    },

    searchAction() {
      this.rows = []
      let search = {}

      Object.keys(this.search).forEach((key) => {
        if (this.search[key] && (this.search[key] > 0 || this.search[key].length > 0)) {
          search[key] = this.search[key]
        }
      })

      if (Object.values(search).length === 0) {
        this.$swal({
          type: 'info',
          title: '',
          text: 'Selecciona un filtro de búsqueda'
        })

        return
      }

      if (!search['apt_id'] && search['ref'].length < 4) {
        this.$swal({
          type: 'info',
          title: '',
          text: 'El identificador debe tener al menos 4 caracteres'
        })

        return
      }

      this.searching = true

      hapiickApi().post('/v1/columns/search', {
        admin_id: JSON.parse(localStorage.admin).id,
        search: search
      })
        .then(request => {
          this.searching = false
          this.updateTable(request.data.columns)
        })
        .catch((err) => {
          this.searching = false
          this.$swal({
            type: 'error',
            title: 'Error',
            text: 'Error al obtener las columnas.'
          })
        })
    },
    updateTable(info) {
      this.totalColumns = info.length

      if (info.length === 0) {
        this.rows.push({ 'product_identifier': 'no encontrado' })
        return
      }

      this.rows = [...info]
      this.totalColumns = this.rows.length

      const column_installed = this.columns.findIndex((a) => a.field === 'installed')

      if (this.search['ref']) {
        if (column_installed !== -1) {
          this.columns.splice(column_installed, 1)
        }
        return
      }

      if (column_installed === -1) {
        this.columns.push({ label: 'Instalada en máquina', field: 'installed' })
      }

      this.rows.forEach(col => {
        col.installed = this.search['apt_id'] && this.search['apt_id'] === col.apt_id
      });

    },
    fillAptsOptions(data) {
      this.aptsOptions = data.map((a) => {
        return {
          key: a.Apt.id,
          text: a.LanguagesApts[0].name,
          value: a.Apt.id
        }
      });

      this.aptsOptions.unshift({ key: null, text: '', value: null })
    },
    columnInfo(params) {
      let routeData = this.$router.resolve('/inventory/stock/detail/' + params.row.id);
      window.open(routeData.href, '_blank');
    },
    goTo(where) {
      this.$router.push(where)
    }
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Inventory/columnList.vue